import React from "react";
import SelectableTable from "../SelectableTable/Main.js";
import InputFormTable from "../InputFormTable/Main.js";
import update from "immutability-helper";
import { connect } from "react-redux";
import { linkHeaderAction } from "../../redux/ui/actions";
import { changeSwModeAction } from "../../redux/app/actions";
import Sw from "../common/Sw";
import { getBoolListForSelectedEnv } from "./util.js";

const initData = {
    environment: [
        {
            envType: "river",
            envID: 0,
            envName: "石狩川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
        {
            envType: "river",
            envID: 1,
            envName: "豊平川",
            envPath: "[W05-09_01-g_Stream.shp]",
            envRegion: "北海道",
        },
    ],

    region: [
        {
            regionName: "札幌",
            regionID: 0,
            regionCoordSystem: "Exxx",
            regionRange: '{"x1":141.00,"x2":142.00,"y1":43.00,"y2":44.00}',
            env: [
                {
                    envType: "river",
                    envID: 0,
                    envName: "石狩川",
                    envPath: "[W05-09_01-g_Stream.shp]",
                    envRegion: "北海道",
                },
                {
                    envType: "river",
                    envID: 1,
                    envName: "豊平川",
                    envPath: "[W05-09_01-g_Stream.shp]",
                    envRegion: "北海道",
                },
            ],
        },
    ],
};

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            environment: initData["environment"],
            region: initData["region"],
            selectedRegion: null,
            selectedEnvironments: [],
            mode: "list",
            count: 0,
        };
    }

    waiting = (stat) => {
        document.body.style.cursor = stat ? "wait" : "auto";
    };

    /*
     * 環境情報取得
     * environmentフォーマットは
     * initData["environment"]と同じ
     */
    loadRegion = async () => {
        const origin = window.location.origin;
        await fetch(`${origin}/api/region`)
            .then((res) => res.json())
            .then((res) => {
                console.log("RegionEditor loadRegion:", JSON.stringify(res));
                this.setState({
                    region: res,
                });
            })
            .catch((err) => console.log(err));
    };

    /*
     * 地域情報取得
     * regionフォーマットは
     * initData["region"]と同じ
     */
    loadEnvironment = async () => {
        const origin = window.location.origin;
        await fetch(`${origin}/api/environment`)
            .then((res) => res.json())
            .then((res) => {
                this.setState({ environment: res });
            })
            .catch((err) => console.log(err));
        console.log("EnvironmentEditor loadEnvironment done");
    };

    async componentDidMount() {
        await this.loadRegion();
        await this.loadEnvironment();
    }

    /* 地域情報リスト画面のイベントハンドラ */
    //地域情報新規作成画面へ遷移
    onAdd = (e) => {
        console.log("onAdd");
        this.setState({ mode: "add" });
    };

    //地域情報修正画面へ遷移
    onModify = (e) => {
        console.log("onModify");
        if (this.state.selectedRegion) {
            this.setState({ mode: "modify" });
        }
    };

    //地域情報の削除
    onDelete = async (e) => {
        if (!window.confirm("本当に削除しますか?")) {
            return;
        }
        if (!this.state.selectedRegion) {
            return;
        }
        console.log("onDelete:", this.state.selectedRegion, this.state.selectedRegion.regionID);

        const origin = window.location.origin;
        await fetch(`${origin}/api/region/${this.state.selectedRegion.regionID}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                console.log("onDelete res:", res);
                this.setState({ mode: "list" });
                this.setState({ region: res });
                this.setState({ selectedRegion: null });
            })
            .catch((err) => console.log(err));
    };

    //指定した地域のデータセットの作成をサーバに要求
    onCreateDataset = async (e) => {
        if (!this.state.selectedRegion) {
            return;
        }
        console.log("onCreateDataset:", this.state.selectedRegion, this.state.selectedRegion.regionID);

        this.waiting(true);

        const origin = window.location.origin;
        await fetch(`${origin}/api/region/${this.state.selectedRegion.regionID}/dataset`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((res) => {
                console.log("onCreateDataset done:", res);
                this.waiting(false);
            })
            .catch((err) => console.log(err));
    };

    //地域情報の選択
    onRegionCheckedChange = (checked, index) => {
        console.log("onRegionCheckedChange:", checked, index);
        let selectedRegion;
        if (checked) {
            selectedRegion = this.state.region[index];
        } else {
            selectedRegion = null;
        }

        console.log("onRegionCheckedChange:", JSON.stringify(selectedRegion));
        this.setState({
            selectedRegion: selectedRegion,
            selectedEnvironments: selectedRegion.env,
        });
    };

    /* 地域情報新規作成/修正画面のイベントハンドラ */
    //地域で使う環境の選択
    onEnvCheckedChange = (checked, index) => {
        console.log("onRegionCheckedChange:", checked, index);
        let selected = this.state.environment[index];
        let selectedEnvironments;
        if (checked) {
            let selected = this.state.environment[index];
            selectedEnvironments = update(this.state.selectedEnvironments, { $push: [selected] });
        } else {
            selectedEnvironments = [...this.state.selectedEnvironments.filter((e) => e.envID != selected.envID)];
        }

        console.log("onRegionCheckedChange:", JSON.stringify(selectedEnvironments));

        this.setState({ selectedEnvironments: selectedEnvironments });
    };

    /*
     * 地域情報の追加(POST)/更新(PUT)
     * POST/PUTのregionフォーマットは
     * initData["region"]と同じ
     * POST時はサーバ側で新規にregionIDを生成するため、regionIDは指定しない
     */
    onUpdateRegion = async (region) => {
        const origin = window.location.origin;
        console.log("Editregion:", region);

        let url;
        let method;

        if (this.state.mode == "add") {
            url = `${origin}/api/region`;
            method = "POST";
        } else if (this.state.mode == "modify") {
            const regionID = this.state.selectedRegion.regionID;
            url = `${origin}/api/region/${regionID}`;
            method = "PUT";
        }

        await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                ...region,
                env: this.state.selectedEnvironments,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({ mode: "list" });
                this.setState({ region: res });
            })
            .catch((err) => console.log(err));
    };

    //新規追加/修正のキャンセル
    onCancelEdit = () => {
        this.setState({ mode: "list" });
    };

    render() {
        if (this.state.mode === "list") {
            //地域情報リスト画面
            console.log(JSON.stringify(this.state.region));

            return (
                <div>
                    <SelectableTable key="1" inputType="radio" name="region" onCheckChange={this.onRegionCheckedChange} dataList={this.state.region} excludedNames={["env"]} />
                    <div className="l-row">
                        <button className="sBtn" key="region add" onClick={this.onAdd}>
                            新規
                        </button>
                        <button className="sBtn l-mlS" key="region mod" onClick={this.onModify}>
                            修正
                        </button>
                        <button className="sBtn l-mlS" key="region del" onClick={this.onDelete}>
                            削除
                        </button>
                        <button className="sBtn l-mlS" key="region dataset" onClick={this.onCreateDataset}>
                            データセット作成
                        </button>
                    </div>
                </div>
            );
        } else {
            //地域情報新規追加/修正画面

            //選択した地域に設定されている環境をデフォルトでチェックするためのリスト
            let defaultCheckedList = [];

            if (this.state.selectedRegion) {
                defaultCheckedList = getBoolListForSelectedEnv(this.state.selectedRegion.env, this.state.environment);
            }
            /*
                        if (this.state.selectedRegion) {
                            const selectedEnvID = [];
                            for (let e of this.state.selectedRegion.env) {
                                selectedEnvID.push(e.envID);
                            }

                            this.state.environment.forEach((e, index) => {
                                if (selectedEnvID.includes(e.envID)) {
                                    defaultCheckedList.push(true);
                                } else {
                                    defaultCheckedList.push(false);
                                }
                            });
                        }
            */

            return (
                <Sw title="地域情報追加">
                    <div id="RegionEditor">
                        <InputFormTable
                            onClickOK={this.onUpdateRegion}
                            onClickCancel={this.onCancelEdit}
                            data={this.state.selectedRegion ? this.state.selectedRegion : { regionName: "", regionCoordSystem: "", regionRange: "" }}
                            excludedNames={["env"]}
                        />
                        <SelectableTable key="1" inputType="checkbox" name="region" onCheckChange={this.onEnvCheckedChange} dataList={this.state.environment} defaultCheckedList={defaultCheckedList} />
                    </div>
                </Sw>
            );
        }
        return <React.Fragment></React.Fragment>;
    }
}

export default Main;
